import styled from "@emotion/styled";
import { ModalTercerosInvolucrados } from "./ModalTercerosInvolucrados";
import { ModalPersonasLesionadas } from "./ModalPersonasLesionadas";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { useState } from "react";
import { GuardarSiniestro } from '../../../../../Services/API/GuardarSiniestro';
import { guardarArchivoSiniestro } from '../../../../../Services/API/GuardarArchivoSiniestro';
import { SegButton } from "../../../../../Components/SegUI/SegButton/SegButton";
import { StepComponentProps } from "../../Siniestros";
import { SiniestroData, useSiniestroStore } from "../../../../../Services/Providers/SiniestroStore";
import { SegSelect } from "../../../../../Components/SegUI/SegSelect/SegSelect";
import localforage from "localforage";

const ToggleContainer = styled.div`
  margin: 2rem 0;
  
  .toggle-section {
    margin-bottom: 2rem;
    
    .toggle-content {
      margin-top: 1.5rem;
      padding: 1.5rem;
      background-color: #f8f9fa;
      border-radius: 8px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    }
  }
`;


export const AccidenteTransitoTerceros = ({ setSteps, config }: StepComponentProps) => {

    const { siniestroValues, setSiniestroValues } = useSiniestroStore();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [enviado, setEnviado] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState('');

    const methods = useForm({
        mode: 'onChange',
        defaultValues: {
            huboTerceros: null as string | null,
            huboLesionados: false,
        }
    });

    const { register, watch, handleSubmit, setValue } = methods;

    const huboTercerosValue = watch("huboTerceros");
    const huboLesionadosValue = watch("huboLesionados");

    // Lógica de habilitacion del botón
    const isTercerosValid =
        huboTercerosValue === 'no' ||
        huboTercerosValue === 'si_sin_datos' ||
        (huboTercerosValue === 'si_con_datos' && (siniestroValues.terceros?.length ?? 0) > 0);

    const isLesionadosValid =
        !huboLesionadosValue ||
        (huboLesionadosValue && (siniestroValues.personasLesionadas?.length ?? 0) > 0);

    const isFormReadyToSubmit = isTercerosValid && isLesionadosValid;

    const handleTercerosChange = (option: { label: string, value: string }) => {
        const value = option.value;
        setValue('huboTerceros', value, { shouldValidate: true });

        // Limpiamos la lista de terceros
        if (value === 'no' || value === 'si_sin_datos') {
            setSiniestroValues({
                ...siniestroValues,
                terceros: []
            });
        }
    };


    const onSubmit: SubmitHandler<any> = async (data) => {
        setIsLoading(true);

        const finalSiniestroData = {
            ...siniestroValues,
            huboTerceros: data.huboTerceros !== 'no', // Es true si seleccionó CUALQUIER opción de "Sí"
            huboLesionados: data.huboLesionados,
            terceros: data.huboTerceros === 'si_con_datos' ? siniestroValues.terceros : [],
            personasLesionadas: data.huboLesionados ? siniestroValues.personasLesionadas : [],
            archivos: [],
        };

        const resp = await GuardarSiniestro(finalSiniestroData as SiniestroData);

        if (resp.caseId) {
            setErrorMessage("");
            //const allFiles:any = [...(siniestroValues.documentacion || []), ...(siniestroValues.archivos || [])];

            const allFiles: any = [
                ...(siniestroValues.documentacion || []),
                ...(siniestroValues.archivos || [])
            ].filter(item => item && item.trim().length > 0);

            if (allFiles.length > 0) {
                try {
                    for (const [index, item] of allFiles.entries()) {
                        //console.log(`Subiendo archivo ${index + 1} de ${allFiles.length}...`);

                        await guardarArchivoSiniestro(resp.caseId, item.split(',')[1], "image");

                        //Espera 500 ms entre subidas (ajustable)
                        await new Promise((resolve) => setTimeout(resolve, 500));
                    }
                    
                    await localforage.removeItem("siniestros");
                    useSiniestroStore.getState().setSiniestroValues({});
                    setEnviado(true);

                } catch (error) {
                    console.error('Ocurrió un error al subir uno de los archivos', error);
                    setErrorMessage("La denuncia se guardó, pero falló la subida de archivos.");
                }
            } else {
                setEnviado(true);
            }
        } else {
            setErrorMessage("Ocurrió un error, inténtalo otra vez.");
        }
        console.log(siniestroValues)
        setIsLoading(false);
    }

    return (
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)} className="row justify-content-center pt-4 pb-4">
                <div className="col-md-8">
                    {errorMessage && (
                        <div className="alert alert-danger">{errorMessage}</div>
                    )}
                    <ToggleContainer>
                        <div className="toggle-section">
                            <SegSelect
                                label='¿Hubo terceros involucrados?'
                                name="huboTerceros"
                                selected={huboTercerosValue ? { label: huboTercerosValue === 'no' ? "No" : "Sí", value: huboTercerosValue } : null}
                                setSelected={handleTercerosChange}
                                placeholder="Seleccioná una opción"
                                options={[
                                    { label: "Sí", value: "si_con_datos" },
                                    { label: "Sí, pero no tengo los datos", value: "si_sin_datos" },
                                    { label: "No", value: "no" },
                                ]}
                                width="100%"
                            />
                            {(huboTercerosValue === 'si_con_datos') && (
                                <div className="toggle-content mt-1">
                                    <ModalTercerosInvolucrados />
                                </div>
                            )}
                        </div>

                        <div className="toggle-section">
                            <SegSelect
                                label="¿Hubo personas lesionadas?"
                                name="huboLesionados"
                                openDefault={false}
                                selected={
                                    huboLesionadosValue !== undefined && huboLesionadosValue !== null
                                        ? { label: huboLesionadosValue ? "Sí" : "No", value: huboLesionadosValue ? "si" : "no" }
                                        : null
                                }
                                setSelected={(option) => {
                                    const value = option.value === "si";
                                    setValue("huboLesionados", value, { shouldValidate: true });

                                    if (!value) {
                                        setSiniestroValues({
                                            ...siniestroValues,
                                            personasLesionadas: [],
                                        });
                                    }
                                }}
                                placeholder="Seleccioná una opción"
                                options={[
                                    { label: "Sí", value: "si" },
                                    { label: "No", value: "no" },
                                ]}
                                width="100%"
                            />

                            {huboLesionadosValue && (
                                <div className="toggle-content mt-1">
                                    <ModalPersonasLesionadas />
                                </div>
                            )}
                        </div>
                    </ToggleContainer>
                    {enviado &&
                        <div className="alert alert-success" role="alert">
                            Denuncia enviada correctamente
                        </div>
                    }
                    <div className="text-center mt-4">
                        <SegButton
                            label={isLoading ? "Enviando denuncia" : "Enviar denuncia"}
                            type="submit"
                            disabled={!isFormReadyToSubmit || isLoading || enviado}
                            loading={isLoading}
                            bgColor={config.origen !== "SEGURARSE" ? config.colors.primary : undefined}
                            hoverBgColor={config.origen !== "SEGURARSE" ? config.colors.primary : undefined}
                            hoverBorderColor={config.origen !== "SEGURARSE" ? config.colors.accent : undefined}
                            hoverOpacity={config.origen !== "SEGURARSE"}
                        />
                    </div>
                </div>
            </form>
        </FormProvider>
    )
}